import { Form, Formik } from "formik";

import { HelpRounded } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

import TextField from "@components/Forms/FormInputs/TextField";
import RemoveFromNylasButton from "@components/Sidebar/RemoveFromNylasButton";

import theme from "@theme/index";

interface ISendFromFeatureProperties {
  proxySchema: () => any;
  removeNylasFromUser: () => Promise<void>;
  sendEmailFrom: null | string;
  updateUserSendEmailFrom: (values: { sendEmailFrom: null | string }) => Promise<void>;
}

const SendFromFeature = ({
  proxySchema,
  removeNylasFromUser,
  sendEmailFrom,
  updateUserSendEmailFrom,
}: ISendFromFeatureProperties) => {
  return (
    <Formik
      initialValues={{
        sendEmailFrom: sendEmailFrom || "",
      }}
      onSubmit={updateUserSendEmailFrom}
      validationSchema={proxySchema()}
    >
      {({ isSubmitting, isValid, setFieldValue, values }) => {
        return (
          <Form>
            <Box>
              <Box
                sx={{
                  display: "inline-flex",
                  flexDirection: "column",
                  flexGrow: 0,
                  gap: 1,
                  marginBottom: 3,
                }}
              >
                <Typography color={theme.palette.grey[700]} fontWeight={700} variant="body2">
                  Connected Email
                </Typography>
                <RemoveFromNylasButton removeNylasFromUser={removeNylasFromUser} />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 0,
                  gap: 0.5,
                }}
              >
                <Box
                  sx={{
                    alignItems: "center",
                    display: "flex",
                    gap: 0.5,
                  }}
                >
                  <Typography color={theme.palette.grey[700]} fontWeight={700} variant="body2">
                    Alternate From Address
                  </Typography>
                  <Tooltip
                    placement="top"
                    title="Use an alternate 'From' address for your emails. Ideal for shared inboxes and requires IT team setup. Please reach out for more information."
                  >
                    <HelpRounded color="info" />
                  </Tooltip>
                </Box>
                <TextField isDisabled={isSubmitting} label="" name="sendEmailFrom" size="small" type="text" />
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                  }}
                >
                  <Button
                    disabled={isSubmitting || !isValid || !values.sendEmailFrom}
                    sx={{
                      marginTop: 1,
                      width: "110px",
                    }}
                    type="submit"
                    variant="contained"
                  >
                    {isSubmitting ? (
                      <>
                        <CircularProgress size={20} />
                      </>
                    ) : (
                      "Update"
                    )}
                  </Button>
                  {values.sendEmailFrom && (
                    <Button
                      color="error"
                      disabled={isSubmitting || !isValid}
                      onClick={() => {
                        updateUserSendEmailFrom({ sendEmailFrom: null });
                        setFieldValue("sendEmailFrom", "");
                      }}
                      sx={{
                        marginTop: 1,
                        width: "110px",
                      }}
                    >
                      {isSubmitting ? null : "Remove"}
                    </Button>
                  )}
                </Box>
              </Box>
            </Box>
          </Form>
        );
      }}
    </Formik>
  );
};

export default SendFromFeature;
